import styled from "styled-components";
import {
  BREAKPOINT,
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
} from "../../../constants/Styles";

export const CategoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2rem;
`;

export const SearchContainer = styled.div`
  max-width: 100vw;
`;

export const Title = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size64};
  font-weight: ${FONT_WEIGHT.weight700};
  margin-bottom: 1rem;

  @media (max-width: ${BREAKPOINT}) {
    font-size: ${FONT_SIZE.size32};
  }
`;

export const EmptyBackground = styled.div`
  background-color: ${COLORS.background};
  height: 100%;
  width: 100%;
`;
